import { logout } from '@/services/authentication_service'
import { getAction } from '@/store/utils.js'
import { getUserInfo } from '@/services/authentication_service.js'
import { Role } from '@/constants/DoITConstant.js'

export const AUTHENTICATE_STORE = 'auth'

const Actions = {
  LOAD_FROM_SERVER: 'LOAD_FROM_SERVER',
  LOGOUT: 'LOGOUT',
}

const Getters = {
  IS_ADMIN: 'IS_ADMIN',
  DOCUMENT_PERMISSIONS: 'DOCUMENT_PERMISSIONS',
  GROUP_PERMISSIONS: 'GROUP_PERMISSIONS',
  TAG_PERMISSIONS: 'TAG_PERMISSIONS',
}

const Mutations = {
  UPDATE_USER: 'UPDATE_USER',
}

export const AuthenticateStore = {
  namespaced: true,
  state: {
    user: null,
  },
  mutations: {
    [Mutations.UPDATE_USER]: (state, user) => {
      state.user = user
    },
  },
  actions: {
    [Actions.LOAD_FROM_SERVER]: async (context) => {
      const user = await getUserInfo()
      context.commit(Mutations.UPDATE_USER, user)
    },
    [Actions.LOGOUT]: (context) => {
      context.commit(Mutations.UPDATE_USER, null)
      logout().then()
    },
  },
  getters: {
    isAuthenticated: (state) => state.user != null,
    [Getters.IS_ADMIN]: (state) => state.user && state.user.roles.includes(Role.ROLE_ADMIN),
    [Getters.DOCUMENT_PERMISSIONS]: (state) => state.user ? state.user.documentPermissions : [],
    [Getters.TAG_PERMISSIONS]: (state) => state.user ? state.user.tagPermissions : [],
    [Getters.GROUP_PERMISSIONS]: (state) => state.user ? state.user.groupPermissions : [],
  },
}

export const AuthenticateAction = {
  LOAD_FROM_SERVER: getAction(AUTHENTICATE_STORE, Actions.LOAD_FROM_SERVER),
  LOGOUT: getAction(AUTHENTICATE_STORE, Actions.LOGOUT),
}

export const AuthenticateGetter = {
  IS_ADMIN: getAction(AUTHENTICATE_STORE, Getters.IS_ADMIN),
  DOCUMENT_PERMISSIONS: getAction(AUTHENTICATE_STORE, Getters.DOCUMENT_PERMISSIONS),
  TAG_PERMISSIONS: getAction(AUTHENTICATE_STORE, Getters.TAG_PERMISSIONS),
  GROUP_PERMISSIONS: getAction(AUTHENTICATE_STORE, Getters.GROUP_PERMISSIONS),
}
